<script>
  import { createEventDispatcher } from 'svelte';
  import { currentSection } from '../stores/adminStore';

  const dispatch = createEventDispatcher();

  const sections = [
    { id: 'dashboard', label: 'Dashboard', icon: 'grid' },
    { id: 'apps', label: 'Apps', icon: 'apps' },
    { id: 'resources', label: 'Resources', icon: 'cpu' },
    { id: 'settings', label: 'Settings', icon: 'settings' },
    { id: 'logs', label: 'Logs', icon: 'logs' },
  ];

  const iconPaths = {
    grid: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
    apps: '<rect x="2" y="2" width="20" height="20" rx="3"/><line x1="8" y1="2" x2="8" y2="22"/><line x1="16" y1="2" x2="16" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/>',
    cpu: '<rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/>',
    settings: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.32 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
    logs: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>',
  };

  function navigate(sectionId) {
    currentSection.set(sectionId);
  }
</script>

<aside class="sidebar">
  <div class="sidebar-header">
    <div class="logo-circle">
      <span class="logo-ms">MS</span>
      <span class="logo-trade">TRADE</span>
    </div>
    <div class="sidebar-title">
      <span class="title-main">Admin Panel</span>
      <span class="title-sub">Platform Control</span>
    </div>
  </div>

  <nav class="sidebar-nav">
    {#each sections as section}
      <button
        class="nav-item"
        class:active={$currentSection === section.id}
        on:click={() => navigate(section.id)}
        id="nav-{section.id}"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          {@html iconPaths[section.icon]}
        </svg>
        <span class="nav-label">{section.label}</span>
        {#if $currentSection === section.id}
          <div class="active-indicator"></div>
        {/if}
      </button>
    {/each}
  </nav>

  <div class="sidebar-footer">
    <a href="https://msalgoai.com" class="back-link" id="back-home-link">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 12H5"/><polyline points="12 19 5 12 12 5"/>
      </svg>
      Back to Launcher
    </a>
  </div>
</aside>

<style>
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: var(--sidebar-width);
    height: 100vh;
    background: rgba(10, 14, 21, 0.95);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-right: 1px solid var(--border-default);
    display: flex;
    flex-direction: column;
    z-index: 100;
    overflow-y: auto;
  }

  .sidebar-header {
    padding: 24px 20px;
    border-bottom: 1px solid var(--border-default);
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .logo-circle {
    width: 42px;
    height: 42px;
    min-width: 42px;
    border-radius: 50%;
    border: 2px solid var(--neon-blue);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 14px rgba(59, 130, 246, 0.3);
  }

  .logo-ms {
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
    color: var(--text-primary);
    letter-spacing: -0.02em;
  }

  .logo-trade {
    font-size: 6px;
    font-weight: 600;
    color: var(--text-secondary);
    letter-spacing: 0.15em;
    text-transform: uppercase;
    line-height: 1;
    margin-top: 1px;
  }

  .sidebar-title {
    display: flex;
    flex-direction: column;
  }

  .title-main {
    font-size: 15px;
    font-weight: 700;
    color: var(--text-primary);
  }

  .title-sub {
    font-size: 11px;
    color: var(--text-secondary);
    margin-top: 1px;
  }

  .sidebar-nav {
    flex: 1;
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: var(--radius-sm);
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    position: relative;
    width: 100%;
    text-align: left;
  }

  .nav-item:hover {
    background: rgba(255, 255, 255, 0.04);
    color: var(--text-primary);
  }

  .nav-item.active {
    background: rgba(59, 130, 246, 0.1);
    color: var(--neon-blue);
  }

  .nav-item.active svg {
    filter: drop-shadow(0 0 6px rgba(59, 130, 246, 0.4));
  }

  .active-indicator {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 24px;
    background: var(--neon-blue);
    border-radius: 0 3px 3px 0;
    box-shadow: 0 0 8px rgba(59, 130, 246, 0.5);
  }

  .nav-label {
    flex: 1;
  }

  .sidebar-footer {
    padding: 16px 12px;
    border-top: 1px solid var(--border-default);
  }

  .back-link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    border-radius: var(--radius-sm);
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;
  }

  .back-link:hover {
    background: rgba(255, 255, 255, 0.04);
    color: var(--text-primary);
  }

  @media (max-width: 768px) {
    .sidebar {
      position: fixed;
      top: auto;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: auto;
      flex-direction: row;
      border-right: none;
      border-top: 1px solid var(--border-default);
    }

    .sidebar-header,
    .sidebar-footer { display: none; }

    .sidebar-nav {
      flex-direction: row;
      justify-content: space-around;
      padding: 8px;
      width: 100%;
      gap: 0;
    }

    .nav-item {
      flex-direction: column;
      gap: 4px;
      padding: 8px 6px;
      font-size: 10px;
      align-items: center;
    }

    .nav-label { font-size: 10px; }
    .active-indicator { display: none; }
  }
</style>
